module.exports = __webpack_public_path__ + "static/media/small-ice-right.2cf713f7.png";